import { Logger } from 'bernie-logger';
import { bffFetch, Headers } from './bff-fetch';

export class TripDetailsSource {
  private host: string;
  private logger: Logger;
  private forwardedHeaders: Headers;

  constructor(host = '', logger, forwardedHeaders: Headers = {}) {
    this.host = host;
    this.logger = logger;
    this.forwardedHeaders = forwardedHeaders;
  }

  public fetch({ context, criteria, hotelId }) {
    return bffFetch(this.host, `hotel/${hotelId}/trip`, context, criteria, this.logger, this.forwardedHeaders);
  }
}
